import { render, staticRenderFns } from "./PublicOverviewProvider.vue?vue&type=template&id=72275e97"
import script from "./PublicOverviewProvider.vue?vue&type=script&lang=js"
export * from "./PublicOverviewProvider.vue?vue&type=script&lang=js"
import style0 from "./PublicOverviewProvider.vue?vue&type=style&index=0&id=72275e97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports